module.exports = __webpack_public_path__ + "img/loader_Overlay.cb055d93.png";